import {
  REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS,
  REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
  REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
  REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
  REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER,
  REPORT_CLIENT_TO_CONTACT_NO_ORDER,
  REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
  REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
  REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
} from '/enum/records.enum';

export const NO_ORDER = 'noOrder';
export const PREMIER_CANCELLATIONS = 'premierCancellations';
export const RECENTLY_INACTIVE = 'recentlyInactive';
export const EXPIRING_WELLNESS_CREDITS = 'expiringWellnessCredits';
export const EXPIRING_REWARDS = 'expiringRewards';
export const NEXT_TASK = 'nextTask';
export const NO_ACTIVE_ORDER = 'noActiveOrders';
export const NO_RX_ORDER = 'noRXOrder';
export const NEW_CANDIDATE = 'candidates';

export const CLIENT_TO_CONTACT_REPORT_ENUM = {
  [REPORT_CLIENT_TO_CONTACT_NO_ORDER]: NO_ORDER,
  [REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS]: EXPIRING_REWARDS,
  [REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE]: RECENTLY_INACTIVE,
  [REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION]: PREMIER_CANCELLATIONS,
  [REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS]:
    EXPIRING_WELLNESS_CREDITS,
  [REPORT_CLIENT_TO_CONTACT_NEXT_TASK]: NEXT_TASK,
  [REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER]: NO_ACTIVE_ORDER,
  [REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER]: NO_RX_ORDER,
  [REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE]: NEW_CANDIDATE,
};

export const CLIENTS_TO_CONTACT = 'Clients to Contact';
export const PEOPLE_TO_CONTACT = 'People to Contact';
